<template>
	<div class="shop-container">
		<div class="t" v-if="pageShow">
			<div class="tl">
				<div class="tl-img">
					<i v-if="status == 2" class="icon  iconfont iconsuccess"></i>

         			 <img v-else class="fail" src="@/assets/icon/fail.png" alt>
				</div>
				<div class="tl-info">
					<h3 v-if="status == 2">{{$t('addedToCartSuccessfully')}}!</h3>
         			 <h3 v-else>Fail!</h3>
				</div>
			</div>
			<div class="tr">
				<div class="tr-btn back" @click="$router.replace('home')">{{ $t('goHome') }}</div>
				<div class="tr-btn go">
					<router-link :to="{ name: 'orderDetail', params: { order_id: (order_id + '').substr(0, 17) } }">{{ $t('moredetails') }}</router-link>
				</div>
			</div>
		</div>
		<!-- <div class="b">
			<div class="title">
				<h2>{{ $t('othersHaveBoughtThem') }}</h2>
				<ProductRowFive :list="goodsList"></ProductRowFive>
			</div>
		</div> -->
	</div>
</template>

<script>
import ProductRowFive from '@/components/layout/ProductRowFive.vue';
export default {
	name: 'PaySuccess',
	components: { ProductRowFive },
	props: {},
	data() {
		return {
			order_id: '',
			goodsList: [],
			orderInfo: {},
			status: '',
			pageShow: false
		};
	},
	methods: {
		getPickGoods() {
			let data = {
				page: 1,
				limit: 10
			};
			this.$api.getPickGoods(data).then(res => {
				if (res.status) {
					this.goodsList = res.data.list;
				}
			});
		},
		getOrderDetail() {
			let data = {
				order_id: this.order_id
			};
			this.$api.orderDetail(data).then(res => {
				if (res.status) {
					this.orderInfo = res.data;
					//只统计成功的
					if(Number(res.data.pay_status)==2){
						this.googleAd();
						this.facebookAd();
					}
				}
			});
		},
		googleAd() {
			let orders = this.$storage.get("google_orders")||[];
			
			if(orders.length > 0 && orders.indexOf(this.order_id)>-1){
				return true;
			}
			window.dataLayer = window.dataLayer || [];
			
			let items = [];
			let transactionProducts = [];

			for (let i of this.orderInfo.items) {
				items.push({ id: i.product_id, google_business_vertical: 'retail' });

				transactionProducts.push({ sku: i.addon, name: i.name, price: i.price, quantity: i.nums });
			}
			// 12312312
			// Universal Analytics 电子商务
			window.dataLayer.push({
				transactionId: this.orderInfo.order_id, // 订单号？
				transactionTotal: this.orderInfo.order_amount, // 商品总价格？
				transactionProducts: transactionProducts,
				currency: 'USD'
			});
			// Google Ads 动态再营销
			window.dataLayer.push({
				event: 'purchase', // 购买操作
				value: this.orderInfo.order_amount, // 这个 值哪里来的
				items: items,
				transaction_id: this.orderInfo.order_id,
				currency: 'USD'
			});
			orders.push(this.order_id);
			this.$storage.set("google_orders", orders);
			
			console.log('orders', orders);
		},
		facebookAd() {
			let orders = this.$storage.get('facebook_orders') || [];
			if (orders.length > 0 && orders.indexOf(this.order_id) > -1) {
				return true;
			}
			let userInfo = this.$storage.get('userInfo');
			let items = [];
			let content_ids = [];
		
			let productNums = 0;
			for (let i of this.orderInfo.items) {
				items.push({ id: i.product_id, quantity: i.nums });
				content_ids.push(i.product_id);
				productNums += parseFloat(this.orderInfo.items[i].nums);
			}
			
			let purchase = {
				content_ids: content_ids,
				content_name: this.orderInfo.order_id,
				content_type: 'product_group',
				contents: items,
				num_items: productNums,
				currency: 'USD',
				value: this.orderInfo.order_amount
			};
			window.fbq('track', 'Purchase', purchase);
			orders.push(this.order_id);
			this.$storage.set('facebook_orders', orders);
		}
	},
	created() {},
	mounted() {
		if (this.$storage.get("userToken")) {
			this.$api.paymentInfo({
				payment_id: this.$route.query.id,
				params: {
				payerid: this.$route.query.PayerID,
				token: this.$route.query.token
				}
				
			}).then(res => {
				this.status = res.data.status

				setTimeout(() => {
					this.pageShow = true
				}, 50)
			})
		}


		let order_id = this.$route.query.order_id || this.$route.query.id;
		this.order_id = order_id;
		this.getPickGoods();
		this.getOrderDetail();
		
		let userInfo = this.$storage.get('userInfo');
		window.gtag('set', 'user_data', {
			"email": userInfo.email//订单提交的信箱变数,
		});
		window.gtag('event', 'conversion', {
			'send_to': 'AW-581690234/tfqhCJmel50YEPrGr5UC',
			'value': 1,
			'currency': 'USD'
		});
	}
};
</script>
<style lang="scss" scoped>
@import '~@/assets/css/variable.scss';
.shop-container {
	padding-top: 20px;
}

.fail {
  width: 64px;
  height: 64px;
}
.t {
	margin-bottom: 26px;
	padding: 0 0 28px 0;
	height: 68px;
	border-bottom: 1px solid #e0e0e0;
	.tl {
		.tl-img {
			float: left;
			width: 64px;
			height: 64px;
			margin-right: 20px;
			.icon {
				font-size: 64px;
				color: #84c54d;
			}
		}
		.tl-info {
			float: left;
			h3 {
				color: #424242;
				font-size: 22px;
				font-weight: normal;
				margin-top: 20px;
			}
		}
	}
	.tr {
		float: right;
		.tr-btn {
			display: inline-block;
			width: 180px;
			margin-left: 12px;
			margin-top: 5px;
			height: 38px;
			line-height: 38px;
			text-align: center;
			cursor: pointer;
			-webkit-transition: all 0.4s;
			transition: all 0.4s;
			&.back {
				border: 1px solid #b0b0b0;
				color: #757575;
				&:hover {
					background: #fff;
				}
			}
			&.go {
				background: $theme-color;
				color: #fff;
				border: 1px solid $theme-color;
			}
		}
	}
}
.b {
	.title {
		h2 {
			text-align: center;
			height: 50px;
			font-size: 28px;
			font-weight: 400;
			color: #757575;
			margin-bottom: 20px;
		}
	}
}
</style>
